import React, { Component } from "react";
import flatpickr from "flatpickr";
import {
	decDaysToDate,
	formatDateToComputerDate,
	formatDateToLocalDate,
	getDiffBetweenTwoDates,
	getFirstDayOfMonth,
	getLastDayOfMonth,
	incDaysToDate,
	FlatpickrLocalePT
} from "../../../../shared/utils";
import PropTypes from "prop-types";

class DatePeriodFilter extends Component {
	constructor(props) {
		super(props);
	}

	differenceBetweenInputedAndEndDate(inputedDate, dateEndDateFilter) {
		return getDiffBetweenTwoDates(
			formatDateToComputerDate(inputedDate),
			formatDateToComputerDate(typeof dateEndDateFilter === 'object' ? formatDateToLocalDate(dateEndDateFilter) : dateEndDateFilter)
		);
	}

	handleChangeDate = dateFilterMethod => {
		if (dateFilterMethod === 2) {
			this.startDateFilter.setDate(
				decDaysToDate(formatDateToComputerDate(new Date()), this.props.maxIntervalBetweenDates)
			);
			this.endDateFilter.setDate(new Date());
		} else {
			this.startDateFilter.setDate(getFirstDayOfMonth(new Date()));
			this.endDateFilter.setDate(getLastDayOfMonth(new Date()));
		}

		this.props.onChange({
			start: formatDateToComputerDate(this.startDateFilter.selectedDates[0]),
			end: formatDateToComputerDate(this.endDateFilter.selectedDates[0])
		});
	};

	componentDidMount() {
		this.startDateFilter = flatpickr("#startDateFilter", {
			disableMobile: "true", // desabilita o datepicker nativo no browser mobile
			locale: FlatpickrLocalePT,
			name: "#startDateFilter",
			dateFormat: "d/m/Y",
			altFormat: "d/m/Y",
			allowInput: true,
			static: true,
			onChange: (selectedDates, dateStr, instance) => {
				// Verifica se a nova data sera maior que a diferenca padrao definida via props
				if (
					this.differenceBetweenInputedAndEndDate(dateStr, this.endDateFilter.selectedDates[0]) >
					this.props.maxIntervalBetweenDates ||
					this.differenceBetweenInputedAndEndDate(dateStr, this.endDateFilter.selectedDates[0]) < 0
				) {
					this.endDateFilter.setDate(
						incDaysToDate(formatDateToComputerDate(dateStr), this.props.maxIntervalBetweenDates)
					);
				}

				this.props.onChange({
					start: formatDateToComputerDate(dateStr),
					end: formatDateToComputerDate(this.endDateFilter.selectedDates[0]),
					dateMethod: {
						label: "Personalizado",
						value: 2
					}
				});
			}
		});

		this.endDateFilter = flatpickr("#endDateFilter", {
			disableMobile: "true", // desabilita o datepicker nativo no browser mobile
			locale: FlatpickrLocalePT,
			name: "#endDateFilter",
			dateFormat: "d/m/Y",
			altFormat: "d/m/Y",
			allowInput: true,
			static: true,
			onChange: (selectedDates, dateStr) => {
				// Verifica se a nova data sera menor que a diferenca padrao definida via props
				if (
					this.differenceBetweenInputedAndEndDate(dateStr, this.startDateFilter.selectedDates[0]) <
					this.props.maxIntervalBetweenDates * -1 ||
					this.differenceBetweenInputedAndEndDate(this.startDateFilter.selectedDates[0], dateStr) <
					0
				) {
					this.startDateFilter.setDate(
						decDaysToDate(formatDateToComputerDate(dateStr), this.props.maxIntervalBetweenDates)
					);
				}

				this.props.onChange({
					start: formatDateToComputerDate(this.startDateFilter.selectedDates[0]),
					end: formatDateToComputerDate(dateStr),
					dateMethod: {
						label: "Personalizado",
						value: 2
					}
				});
			}
		});

		this.handleChangeDate(this.props.dateFilterPeriodMethod);
	}

	componentWillReceiveProps(nextProp, nextContext) {
		const { dateFilterPeriodMethod, startDate, endDate } = nextProp;

		if (this.props.dateFilterPeriodMethod !== dateFilterPeriodMethod) {
			this.handleChangeDate(dateFilterPeriodMethod);
		} else if (startDate && endDate) {
			this.startDateFilter.setDate(incDaysToDate(startDate, 0));
			this.endDateFilter.setDate(incDaysToDate(endDate, 0));
		} else if (
			this.startDateFilter.selectedDates.length &&
			this.endDateFilter.selectedDates.length &&
			false
		) {
			this.startDateFilter.selectedDates = [];
			this.startDateFilter._input.value = "";
			this.endDateFilter.selectedDates = [];
			this.endDateFilter._input.value = "";
		}
	}

	render() {
		return (
			<div className="date-filter-period">
				<div>
					<div className="datepicker">
						<input
							type="text"
							id="startDateFilter"
							name="startDateFilter"
							className={`form-control datepicker--input-date no-shadow no-bold col-xs-8${this.props.dateFilterPeriodMethod === 1 ? " date-period-filter-input-disabled" : ""
								}`}
							placeholder="Escolha uma data"
							data-input
							required
							maxLength={10}
							autoComplete="off"
							disabled={this.props.dateFilterPeriodMethod === 1}
							data-action="date-period-filter-start-date"
						/>
						<i className="icon-calendar" />
						{this.props.errors.start && <p>{this.props.errors.start}</p>}
					</div>
					<div className="label-period">a</div>
					<div className="datepicker">
						<input
							type="text"
							id="endDateFilter"
							name="endDateFilter"
							className={`form-control datepicker--input-date no-shadow no-bold col-xs-8${this.props.dateFilterPeriodMethod === 1 ? " date-period-filter-input-disabled" : ""
								}`}
							placeholder="Escolha uma data"
							data-input
							required
							maxLength={10}
							autoComplete="off"
							disabled={this.props.dateFilterPeriodMethod === 1}
							data-action="date-period-filter-end-date"
						/>
						<i className="icon-calendar" />
						{this.props.errors.end && <p>{this.props.errors.end}</p>}
					</div>
				</div>
				{!this.props.errors.start &&
					!this.props.errors.end && (
						<small>
							* Período máximo para {this.props.isFilter ? "filtro" : "exportação"}:{" "}
							{this.props.maxIntervalBetweenDates} dias
						</small>
					)}
			</div>
		);
	}
}

DatePeriodFilter.propTypes = {
	dateFilterPeriodMethod: PropTypes.number.isRequired,
	maxIntervalBetweenDates: PropTypes.number.isRequired
};

DatePeriodFilter.defaultProps = {
	dateFilterPeriodMethod: 2,
	maxIntervalBetweenDates: 45
};

export default DatePeriodFilter;
